<div class="min-h-screen dark:bg-slate-900 p-4 md:p-8 text-sm text-slate-600 dark:text-slate-300">
  <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight flex items-center gap-3">
        รายงาน Web Stamp
        <span class="text-sm font-black text-amber-600 bg-amber-50 dark:bg-amber-900/30 px-2.5 py-1 rounded-lg">RPFI17</span>
      </h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
        Web Stamp Report — จัดกลุ่มตามผู้ให้ส่วนลด · แสดงชื่อ User ผู้ประทับตรา
      </p>
    </div>
    <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 no-print">
      <div *ngIf="lastFetchedTime"
        class="flex flex-col items-end justify-center text-right shrink-0 w-[112px] h-[46px]">
        <span class="text-[11px] text-slate-400 dark:text-slate-500 font-medium leading-none mb-1 whitespace-nowrap">ดึงข้อมูลล่าสุด</span>
        <span class="text-[13px] font-bold text-slate-600 dark:text-slate-400 leading-none tabular-nums">{{ lastFetchedTime | date:'HH:mm:ss' }}</span>
      </div>
      <button type="button" (click)="onRefresh()" [disabled]="!canSearch || isLoading()" title="รีเฟรช"
        class="p-3 bg-white/95 dark:bg-slate-800/95 text-slate-500 rounded-2xl shadow-sm border border-slate-100/50 dark:border-slate-700 hover:text-amber-500 transition-all flex items-center justify-center cursor-pointer disabled:opacity-40">
        <span class="material-icons">refresh</span>
      </button>
      <button type="button" (click)="onExportExcel()"
        [disabled]="groups.length === 0 || isLoading() || isExporting()"
        class="px-4 py-3 bg-white/95 dark:bg-slate-800/95 text-emerald-600 dark:text-emerald-400 font-bold rounded-2xl shadow-sm border border-emerald-100 dark:border-emerald-900 hover:bg-emerald-50 transition-all flex items-center justify-center gap-2 cursor-pointer disabled:opacity-40">
        <span class="material-icons text-[18px]">table_view</span>
        {{ isExporting() ? 'กำลังส่งออก...' : 'ส่งออก Excel' }}
      </button>
      <button type="button" (click)="onPrintPdf()"
        [disabled]="!hasSearched() || isLoading() || isProcessingPdf()"
        class="px-4 py-3 bg-amber-400 hover:bg-amber-500 text-slate-900 font-bold rounded-2xl shadow-lg shadow-amber-200/50 dark:shadow-none transition-all flex items-center justify-center gap-2 cursor-pointer disabled:opacity-40 border-none">
        <span class="material-icons text-[18px]">picture_as_pdf</span>
        {{ isProcessingPdf() ? 'กำลังสร้าง PDF...' : 'พิมพ์ PDF' }}
      </button>
    </div>
  </div>

  <div class="bg-white/95 dark:bg-slate-800/95 backdrop-blur-sm rounded-[2rem] shadow-sm border border-slate-100/50 dark:border-slate-700 p-5 mb-6 no-print">
    <div class="flex flex-col lg:flex-row lg:items-end gap-4">
      <div class="flex-1 grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">วันเริ่มต้น</label>
          <input type="date" [(ngModel)]="startDate" (ngModelChange)="onFilterChange()"
            class="w-full px-4 py-2.5 rounded-xl border border-slate-200 dark:border-slate-600 bg-white dark:bg-slate-900 text-slate-700 dark:text-slate-200 font-medium outline-none focus:ring-2 focus:ring-amber-300" />
        </div>
        <div>
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">วันสิ้นสุด</label>
          <input type="date" [(ngModel)]="endDate" [attr.max]="maxEndDate" (ngModelChange)="onFilterChange()"
            class="w-full px-4 py-2.5 rounded-xl border border-slate-200 dark:border-slate-600 bg-white dark:bg-slate-900 text-slate-700 dark:text-slate-200 font-medium outline-none focus:ring-2 focus:ring-amber-300" />
        </div>
      </div>
      <button type="button" (click)="onSearch()" [disabled]="!canSearch || isLoading()"
        class="px-6 py-2.5 bg-slate-800 dark:bg-amber-500 text-white dark:text-slate-900 font-bold rounded-xl hover:opacity-90 transition-all disabled:opacity-40 cursor-pointer">
        ค้นหา
      </button>
    </div>
  </div>

  <div class="bg-white/95 dark:bg-slate-800/95 backdrop-blur-sm rounded-[2rem] shadow-sm border border-slate-100/50 dark:border-slate-700 overflow-hidden">
    <div class="p-5 space-y-5 overflow-x-auto custom-scrollbar">
      <div *ngIf="!hasSearched()" class="py-16 text-center text-slate-400">
        <span class="material-icons text-4xl mb-2 block opacity-40">search</span>
        <p class="font-bold">เลือกช่วงวันที่แล้วกดค้นหา</p>
      </div>

      <div *ngIf="hasSearched() && groups.length === 0 && !isLoading()" class="py-16 text-center text-slate-400">
        <span class="material-icons text-4xl mb-2 block opacity-40">inbox</span>
        <p class="font-bold">ไม่พบข้อมูลในช่วงวันที่ที่เลือก</p>
      </div>

      <ng-container *ngFor="let g of groups">
        <div class="rounded-2xl border border-slate-100 dark:border-slate-700 overflow-hidden">
          <div class="px-4 py-2.5 bg-slate-50 dark:bg-slate-900/60 border-b border-slate-100 dark:border-slate-700 font-bold text-slate-700 dark:text-slate-200">
            ผู้ให้ส่วนลด: {{ g.providerName }}
            <span class="ml-2 text-xs font-semibold text-slate-400">({{ g.stampCount | number }} รายการ)</span>
          </div>
          <table class="w-full text-left border-collapse min-w-[1100px] text-xs">
            <thead class="bg-white/95 dark:bg-slate-800/95">
              <tr class="text-[10px] font-bold text-slate-400 uppercase tracking-wider text-center whitespace-nowrap">
                <th class="p-2 border border-slate-100 dark:border-slate-700 w-12">ลำดับ</th>
                <th class="p-2 border border-slate-100 dark:border-slate-700 text-left">เงื่อนไข E-Stamp</th>
                <th class="p-2 border border-slate-100 dark:border-slate-700">ทะเบียนรถ</th>
                <th class="p-2 border border-slate-100 dark:border-slate-700">วันเวลาเข้า</th>
                <th class="p-2 border border-slate-100 dark:border-slate-700">วันเวลาออก</th>
                <th class="p-2 border border-slate-100 dark:border-slate-700">ระยะเวลาจอด</th>
                <th class="p-2 border border-slate-100 dark:border-slate-700 text-left">ผู้ประทับตรา</th>
                <th class="p-2 border border-slate-100 dark:border-slate-700 text-left">หมายเหตุ</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let r of g.rows" class="hover:bg-slate-50/60 dark:hover:bg-slate-700/40 tabular-nums">
                <td class="p-2 border border-slate-50 dark:border-slate-700 text-center">{{ r.seq }}</td>
                <td class="p-2 border border-slate-50 dark:border-slate-700">{{ r.stampCondition }}</td>
                <td class="p-2 border border-slate-50 dark:border-slate-700 text-center font-mono">{{ r.license }}</td>
                <td class="p-2 border border-slate-50 dark:border-slate-700 text-center whitespace-nowrap">{{ formatDateTime(r.entryDateTime) }}</td>
                <td class="p-2 border border-slate-50 dark:border-slate-700 text-center whitespace-nowrap">{{ formatDateTime(r.exitDateTime) }}</td>
                <td class="p-2 border border-slate-50 dark:border-slate-700 text-center whitespace-nowrap">{{ r.parkingDuration || '—' }}</td>
                <td class="p-2 border border-slate-50 dark:border-slate-700">{{ r.stamperName }}</td>
                <td class="p-2 border border-slate-50 dark:border-slate-700">{{ r.remark || '—' }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="bg-slate-50 dark:bg-slate-900/50 font-bold tabular-nums">
                <td class="p-2 border border-slate-100 dark:border-slate-700 text-right" colspan="7">
                  รวม (แยกผู้ให้ส่วนลด)
                </td>
                <td class="p-2 border border-slate-100 dark:border-slate-700 text-right">
                  {{ g.stampCount | number }} รายการ
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </ng-container>

      <div *ngIf="totals && groups.length > 0"
        class="rounded-2xl border-2 border-amber-200 dark:border-amber-800 bg-amber-50/50 dark:bg-amber-950/20 px-5 py-4 flex flex-wrap items-center justify-between gap-3 font-bold">
        <span class="text-slate-700 dark:text-slate-200">รวมทั้งสิ้น (แยกผู้ให้ส่วนลด)</span>
        <span class="tabular-nums text-amber-700 dark:text-amber-300 text-lg">
          {{ totals.stampCount | number }} รายการ
        </span>
      </div>
    </div>
  </div>
</div>

<app-modal-invoice-pdf-viewer
  *ngIf="showPdfModal()"
  [pdfSrc]="pdfSrc"
  [modalTitle]="'RPFI17 — รายงาน Web Stamp (PDF)'"
  [downloadFileName]="pdfDownloadName"
  (close)="closePdfModal()">
</app-modal-invoice-pdf-viewer>

<app-pss-loading *ngIf="isLoading() || isProcessingPdf()"></app-pss-loading>
